import { computed, toValue, type MaybeRefOrGetter, type Ref } from 'vue';
import type { AssignmentsByCaregiver } from './useAssignmentsByCaregiver';

const SATURATION = 70;
const LIGHTNESS = 45;
const FULL_CIRCLE = 360;

// Golden angle (~137.5°) distributes hues maximally apart even for sequential indices
const GOLDEN_ANGLE = 137.508;

export function generateColor(index: number): string {
  const hue = Math.round((index * GOLDEN_ANGLE) % FULL_CIRCLE);

  return `hsl(${hue}, ${SATURATION}%, ${LIGHTNESS}%)`;
}

export function useRouteColors(caregiverIds: Ref<number[]>) {
  const colorMap = computed(() => {
    const map: Record<number, string> = {};
    caregiverIds.value.forEach((id, i) => {
      map[id] = generateColor(i);
    });

    return map;
  });

  return { colorMap, generateColor };
}

// Stable per-caregiver colors derived straight from the grouped assignments, so every
// view (results, applied, map legend) builds the identical caregiverId -> color map.
export function useCaregiverColors(
  assignmentsByCaregiver: MaybeRefOrGetter<AssignmentsByCaregiver>,
) {
  const caregiverIds = computed(() => Object.keys(toValue(assignmentsByCaregiver)).map(Number));

  return useRouteColors(caregiverIds);
}
